Pegasus.RadioButton = Ember.Checkbox.extend({
  classNameBindings: ['type'],
  type: 'radio',
  change: function() {
    this.set('selection', this.get('value'));
  },
  didInsertElement: function(){
    this._super();
    if (this.get('value') === this.get('selection') ){
      this.set('checked', true);
    }
  }
});

Pegasus.CheckboxToggleButton = Ember.Checkbox.extend({
  type: 'checkbox',
  click: function() {
    this.set('selection', this.get('selection') === "false" ? "true" : "false");
  },
  checked: function(_, value){
    return this.get('selection') === this.get('value');
  }.property('selection')
});
